import { Wallet, QrCode, Coins } from "lucide-react";
import Reveal, { Eyebrow } from "@/components/Reveal";

const STEPS = [
  {
    n: "01",
    icon: Wallet,
    title: "Connect your Solana wallet",
    desc: "Link the wallet you already use. No sign-up, no KYC, no custody handover — your keys never leave your device.",
  },
  {
    n: "02",
    icon: QrCode,
    title: "Generate a payment link or QR code",
    desc: "Set an amount, drop in a memo, and share it anywhere — an invoice, a storefront, a livestream overlay.",
  },
  {
    n: "03",
    icon: Coins,
    title: "Customer pays in USDC. You keep 99%.",
    desc: "The payment settles straight to your wallet in about a second. No batching, no rolling reserves, no waiting periods.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      className="scroll-mt-24 border-t border-line py-24 sm:py-32"
      data-testid="how-it-works-section"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <Reveal>
          <Eyebrow>The protocol</Eyebrow>
          <h2 className="mt-4 max-w-2xl text-3xl font-semibold tracking-tight sm:text-4xl lg:text-5xl">
            Three steps. Zero friction.
          </h2>
        </Reveal>

        <div className="mt-16">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08}>
              <div
                className="group grid grid-cols-[auto_1fr] items-start gap-6 border-t border-line py-10 sm:gap-12 sm:py-14"
                data-testid={`step-${s.n}`}
              >
                <span className="text-stroke font-mono text-6xl font-semibold leading-none sm:text-8xl">
                  {s.n}
                </span>
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-10">
                  <div className="max-w-xl">
                    <h3 className="text-xl font-semibold text-white sm:text-2xl lg:text-3xl">
                      {s.title}
                    </h3>
                    <p className="mt-3 text-sm leading-relaxed text-mut sm:text-base">
                      {s.desc}
                    </p>
                  </div>
                  <div className="inline-flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl border border-line bg-card2 transition-colors duration-500 group-hover:border-sgreen/40">
                    <s.icon className="h-6 w-6 text-sgreen" />
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
